const DataStorage = {
  get(key) {
    return localStorage.getItem(key);
  },
  save(key, accessCategory) {
    localStorage.setItem(key, accessCategory);
  }
};
export { DataStorage };
